import {
  faChevronSquareDown,
  faChevronSquareUp,
  faEdit,
  faInfoCircle,
  faTimes,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, Form, Formik } from "formik";
import { cloneDeep, get, isEmpty, min, values } from "lodash";
import React, { useState } from "react";
import * as Yup from "yup";
import { Button } from "react-bootstrap";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInput,
  FieldInputDollar,
  FieldInputDollarBox,
  FieldInputPercentage,
  FieldInputPercentageBox,
  SearchableList,
  SliderPanel,
  WarningModal,
  WithDrawalCard,
} from "../../../components";
import { getCountriesList, getStates } from "../../../services";
import {
  clearFieldValues,
  DISTRIBUTION_WITHDRAWAL_TYPE,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
} from "../../../utils";
import AddressAndBankDetailsComponent from "../WithdrawalRequestContainer/AddressAndBankDetailsComponent";
import DeleteRecipientPopUp from "../WithdrawalRequestContainer/DeleteRecipientPopUp";
import {
  AllowMeToChooseFromOptions,
  CalculateProrationForSourceAllocation,
  distributionTypeEnum,
  DISTRIBUTION_WITHDRAWAL_MODE,
  GetFeesAndTaxes,
  getFilteredRkData,
  getValues,
  PaymentOptions,
  WithdrawalAmountType,
  WithdrawalStrategy,
  ListInvestmentAndTheirAvailableBalance,
  getFullName,
  calculateNetAmountFromGrossAmount,
  SourceAllocationCalculationMethod,
  CustomizeAllocationCalculationMethodEnum,
  calculateGrossAmountFromNetAmountSourceWise,
  feeAndTaxesModel,
  CalculateTotalFees,
  calculateNetAmountFromGrossAmountNew,
  calculateRequestedAmountEffective,
  isAllowMeToChooseTransaction,
  sourceBalanceToSourceAllocationMap,
  CalculateProrationSplitUp,
  getSourceWiseRequestAmountModel,
  getSourceWiseRequestAmountModelInitial,
  isSpecificTenure,
  calculationToBeBasedOnGrossAmount,
  getVestedBalanceWithoutVestingMultiplier,
  isFullWithdrawal,
  DeductProratedSplits,
  calculateEffectiveSourceWithdrawal,
  isAnnutizationOrSpecificTenure,
  CalculateNetAvailableAmountSplit,
  calculateTotalVestedBalanceFromSourceBalance,
  isSpecificDollar,
  withdrawalTypeEnum,
  isPeriodicPayment,
  isFederalTaxApplicable,
  isRolloverDistributionMode,
  shouldIncludePenaltyBasedOnYOS,
} from "../WithdrawalRequestContainer/DistributionConstantsAndFunctions";
import HeadingAndTextComponent from "../WithdrawalRequestContainer/HeadingAndTextComponent";
import { SourceAllocationComponentSlider } from "./SourceAllocationComponentSlider";
import { SummaryComponent } from "./SummaryComponent";
import SourceHierarchyComponent from "../WithdrawalRequestContainer/SourceHierarchyComponent";

function AddWithdrawalAllocation(props) {
  const {
    fields,
    onDeleteAllocation = () => {},
    selectedIndex,
    setSelectedIndex,
    outerValues,
    outerSetValues,
    initialValues,
    filteredValues,
    setWithdrawalSlider,
    maximumWithDrawalAmount,
    sourceBalances,
    setSliderOpen,
    setShowDirtyCheckModal,
    setIsInnerFormDirty,
    employeePlans,
    selectedPlan,
    showDirtyCheckModal,
    handleConfirmClick,
    handleCancelClick,
    onFormToggle,
    isInnerFormDirty,
    sliderOpen,
    selectedWithdrawalPlanSetUp,
    defaultStateTax,
    defaultFederalTax,
    withdrawalAmountForPeriodicPaymentTransaction,
    withdrawalSlider,
    employeePlanDetails,
    ...rest
  } = props;

  const withdrawalRequestData = outerValues;
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const calculationIsBasedOnGrossAmount = calculationToBeBasedOnGrossAmount(
    outerValues
  );
  const { flow, censusId, withdrawalRequestId, fromPage } = useRouterParams();

  const beneficiaries = get(withdrawalRequestData, "beneficiaries", []);
  const [modalVisible, setModalVisible] = useState(false);
  const [filteredSourceBalances, setFilteredSourceBalances] = useState([]);
  const [
    availableBalanceMapForEachSourceInvestment,
    setAvailableBalanceMapForEachSourceInvestment,
  ] = useState([]);
  const [
    initialFilteredSourceBalance,
    setInitialFilteredSourceBalance,
  ] = useState([]);
  console.log(
    "filteredSourceBalances",
    filteredSourceBalances,
    availableBalanceMapForEachSourceInvestment,
    "initialFilteredSourceBalance",
    initialFilteredSourceBalance
  );
  console.log("selectedPlan", selectedPlan);
  const setFilteredSourceBalancesAndAvailableAmountSplit = (
    currentTransactionData_
  ) => {
    const currentTransactionData = cloneDeep(currentTransactionData_);
    let sourceBalancesExcludingPreviousTransactions = cloneDeep(sourceBalances);
    get(outerValues, "withdrawalTransactions", [])
      .filter((x, ind) => ind !== selectedIndex)
      .forEach((transaction_) => {
        let effectiveSourceWithdrawalForThisTransaction = getFilteredRkData(
          sourceBalancesExcludingPreviousTransactions,
          false,
          outerValues,
          transaction_,
          0
        );
        effectiveSourceWithdrawalForThisTransaction = calculateEffectiveSourceWithdrawal(
          transaction_,
          outerValues,
          effectiveSourceWithdrawalForThisTransaction
        );
        sourceBalancesExcludingPreviousTransactions = DeductProratedSplits(
          sourceBalancesExcludingPreviousTransactions,
          effectiveSourceWithdrawalForThisTransaction,
          1
        );
      });
    const filteredRkDataTemp = getFilteredRkData(
      sourceBalancesExcludingPreviousTransactions,
      false,
      outerValues,
      currentTransactionData,
      0
    );
    setFilteredSourceBalances(filteredRkDataTemp);
    const availableBalanceMapForEachSourceInvestmentTemp = CalculateProrationForSourceAllocation(
      filteredRkDataTemp,
      0,
      true
    );
    setAvailableBalanceMapForEachSourceInvestment(
      availableBalanceMapForEachSourceInvestmentTemp
    );
    if (isEmpty(initialFilteredSourceBalance))
      setInitialFilteredSourceBalance(filteredRkDataTemp);
    return availableBalanceMapForEachSourceInvestmentTemp;
  };

  const onCancelClick = () => {
    setWithdrawalSlider(false);
    setShowDeleteConfirmation(false);
    setModalVisible(false);
  };

  const isEarlyWithdrawalPenaltyApplicable = (transaction) =>
    [
      DISTRIBUTION_WITHDRAWAL_MODE.self,
      DISTRIBUTION_WITHDRAWAL_MODE.beneficiary,
    ].includes(transaction[fields.distributionMode]) &&
    [
      DISTRIBUTION_WITHDRAWAL_TYPE.In_Service,
      DISTRIBUTION_WITHDRAWAL_TYPE.Hardship,
    ].includes(outerValues[fields.withdrawalType]) &&
    shouldIncludePenaltyBasedOnYOS(
      employeePlanDetails?.employeePlanYOS,
      selectedWithdrawalPlanSetUp,
      outerValues
    );

  const alreadySelectedOptions = get(outerValues, "withdrawalTransactions", [])
    .filter((y, inde) => inde !== selectedIndex)
    .map((_, ind) => {
      return {
        distributionMode: _?.distributionMode,
        beneficiaryId: _?.beneficiaryId,
      };
    });

  const distributionModeOptions = [
    {
      label: "Self",
      distributionMode: 1,
    },
    {
      label: "Traditional IRA",
      distributionMode: 2,
    },
    {
      label: "Roth IRA",
      distributionMode: 3,
    },
    {
      label: "Employer Sponsored Plan",
      distributionMode: 4,
    },
    ...(selectedWithdrawalPlanSetUp?.availableToBeneficiaries
      ? beneficiaries
      : []
    ).map((_) => {
      return {
        label: _?.name,
        distributionMode: DISTRIBUTION_WITHDRAWAL_MODE.beneficiary,
        beneficiaryId: _.id,
        beneficiaryName: _.name,
      };
    }),
  ]
    .filter((x, index) => {
      if (
        isPeriodicPayment(outerValues) ||
        outerValues[fields.withdrawalType] === withdrawalTypeEnum.QBAD
      ) {
        if (x.distributionMode === DISTRIBUTION_WITHDRAWAL_MODE.self)
          return true;
        return false;
      }
      if (
        x.distributionMode === DISTRIBUTION_WITHDRAWAL_MODE.roth_IRA ||
        x.distributionMode === DISTRIBUTION_WITHDRAWAL_MODE.traditional_IRA ||
        x.distributionMode === DISTRIBUTION_WITHDRAWAL_MODE.employer_Sponsored
      ) {
        return [
          DISTRIBUTION_WITHDRAWAL_TYPE.Separation_from_Service,
          DISTRIBUTION_WITHDRAWAL_TYPE.In_Service,
        ].includes(outerValues[fields.withdrawalType])
          ? true
          : false;
      }
      return x.distributionMode === DISTRIBUTION_WITHDRAWAL_MODE.beneficiary
        ? !alreadySelectedOptions
            .map((_) => _.beneficiaryId)
            .includes(x.beneficiaryId)
        : !alreadySelectedOptions
            .map((_) => _.distributionMode)
            .includes(x.distributionMode);
    })
    .map((_, ind) => {
      return {
        ..._,
        value: ind,
      };
    });

  const distributionModeInitialValues = distributionModeOptions.find(
    (_) => _.distributionMode == DISTRIBUTION_WITHDRAWAL_MODE.self
  )?.distributionMode;
  const [
    remainingGrossAmountToBeWithdrawnInitial,
    setRemainingGrossAmountToBeWithdrawnInitial,
  ] = useState(null);
  if (
    (initialValues[fields.distributionMode] || distributionModeInitialValues) &&
    isEmpty(initialFilteredSourceBalance) &&
    !isEmpty(sourceBalances)
  ) {
    const availableBalanceMapForEachSourceInvestmentTemp = setFilteredSourceBalancesAndAvailableAmountSplit(
      {
        [fields.distributionMode]:
          initialValues[fields.distributionMode] ||
          distributionModeInitialValues,
      }
    );
    setRemainingGrossAmountToBeWithdrawnInitial(
      getVestedBalanceWithoutVestingMultiplier(
        availableBalanceMapForEachSourceInvestmentTemp
      )
    );
  }
  const remainingGrossAmountToBeWithdrawn = getVestedBalanceWithoutVestingMultiplier(
    availableBalanceMapForEachSourceInvestment
  );
  const maximumGrossWithdrawableAmount = getVestedBalanceWithoutVestingMultiplier(
    filteredSourceBalances
  );
  const defaultEarlyWithdrawalPenalty = isEarlyWithdrawalPenaltyApplicable({
    [fields.distributionMode]: distributionModeInitialValues,
  })
    ? selectedWithdrawalPlanSetUp.earlyWithdrawalPenalty
    : null;
  const effectiveAmountWithdrawn = (remainingGrossAmountFromSourceBalance) =>
    Math.min(
      remainingGrossAmountFromSourceBalance,
      outerValues[fields.netAmountRequested] -
        outerValues[fields.withdrawalFee] -
        get(outerValues, "withdrawalTransactions", [])
          .filter((x, ind) => ind !== selectedIndex)
          .reduce((a, b) => a + b[fields.requestedAmount], 0)
    );
  const initialValuesFormik = {
    [fields.distributionMode]: distributionModeInitialValues,
    [fields.earlyWithdrawalPenalty]: defaultEarlyWithdrawalPenalty,
    [fields.allocatedSourceWithdrawal]: [],
    isCustomSourceAllocation: false,
    [fields.grossAmount]: isFullWithdrawal(outerValues)
      ? isAnnutizationOrSpecificTenure(outerValues)
        ? withdrawalAmountForPeriodicPaymentTransaction
        : effectiveAmountWithdrawn(remainingGrossAmountToBeWithdrawnInitial)
      : // : remainingGrossAmountToBeWithdrawn
        null,
    [fields.stateTax]: defaultStateTax ?? 0,
    [fields.federalTax]: isFederalTaxApplicable(outerValues)
      ? defaultFederalTax
      : 0,
    waiveOffLimitApplicable: false,
    [fields.paymentMethod]: 1,
    [fields.checkFee]: selectedWithdrawalPlanSetUp?.checkFees,
    selectAddressDetails: 1,
    selectBankDetails: 1,
    address: withdrawalRequestData.address,
    [fields.sourceAllocationCalculationMethod]:
      SourceAllocationCalculationMethod.Prorata,
    [fields.customizeAllocationCalculationMethod]:
      CustomizeAllocationCalculationMethodEnum.Source,
  };

  const effectiveNetAmountRequested =
    outerValues[fields.modeOfPayment] === 2
      ? [
          OPTIONS_DATA_MAPPER.PERIODIC_PAYMENT_OPTIONS_ENUM.SpecificDollar,
          OPTIONS_DATA_MAPPER.PERIODIC_PAYMENT_OPTIONS_ENUM.SpecificTenure,
          OPTIONS_DATA_MAPPER.PERIODIC_PAYMENT_OPTIONS_ENUM.AnnuitizationMethod,
        ].includes(outerValues[fields.periodicPaymentType])
        ? withdrawalAmountForPeriodicPaymentTransaction
        : calculateNetAmountFromGrossAmount(
            initialValuesFormik,
            outerValues,
            filteredSourceBalances
          ).reduce(
            (a, b) => a + getValues(b?.sourceEmployeeMap?.accountBalance),
            0
          )
      : maximumWithDrawalAmount;

  const remainingAmountToBeWithdrawn =
    effectiveNetAmountRequested -
    get(outerValues, "withdrawalTransactions", [])
      .filter((x, ind) => ind !== selectedIndex)
      // .map((_) => calculateGrossAmountFromNetAmount(_))
      .reduce((a, b) => a + b[fields.requestedAmount], 0);

  const InvestDetails = ListInvestmentAndTheirAvailableBalance(
    employeePlans[selectedPlan]?.sourceBalances
  );

  const onFormSubmit = (
    values,
    resetForm,
    grossAmountEffective,
    requestedAmountEffective
  ) => {
    let initialSourceHierarchyIndexes = {};
    let initialSourceHierarchies = get(
      initialValues,
      "sourceHierarchyDetails",
      []
    );

    initialSourceHierarchies.forEach((_) => {
      _.investmentHierarchies.forEach((i) => {
        initialSourceHierarchyIndexes[_.sourceId] = {
          id: _.id,
          investmentHierarchies: {
            ...get(
              initialSourceHierarchyIndexes,
              `${_.sourceId}.investmentHierarchies`,
              {}
            ),
            [i.investmentId]: i.id,
          },
        };
      });
    });

    let errorList = [];
    let hierarchyDetails = values[fields.sourceHierarchyDetails] ?? [];
    hierarchyDetails = hierarchyDetails.map((_) => {
      return {
        id: get(initialSourceHierarchyIndexes, `${_.sourceId}.id`, 0),
        investmentHierarchies: _.investmentHierarchies.map((i) => {
          return {
            id: get(
              initialSourceHierarchyIndexes,
              `${_.sourceId}.investmentHierarchies.${i.investmentId}`,
              0
            ),
            ...i,
          };
        }),
        ..._,
      };
    });
    // hierarchyDetails = hierarchyDetails.map(_ => {})
    const transformedValues = {
      ...values,
      [fields.allocatedSourceWithdrawal]: (
        values[fields.allocatedSourceWithdrawal] ?? []
      ).map(sourceBalanceToSourceAllocationMap),
      [fields.requestedAmount]: calculationIsBasedOnGrossAmount
        ? grossAmountEffective
        : requestedAmountEffective,
      taxesAndFees: grossAmountEffective - requestedAmountEffective,
      [fields.sourceHierarchyDetails]: hierarchyDetails,
    };

    if (errorList.length === 0) {
      let withdrawalTransactions = get(
        outerValues,
        "withdrawalTransactions",
        []
      );
      if (selectedIndex === null) {
        withdrawalTransactions.push(transformedValues);
      } else {
        withdrawalTransactions[selectedIndex] = transformedValues;
      }
      outerSetValues({
        ...outerValues,
        withdrawalTransactions: withdrawalTransactions,
      });
      setWithdrawalSlider(false);
    }
  };

  const paymentOptions = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.PAYMENT_OPTIONS
  );
  const codeOptionsRollOver = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.CODE_OPTIONS_ROLLOVER
  );
  const codeOptionsCash = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.CODE_OPTIONS_CASH
  );
  const waiveOffReasonOptions = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.WAIVEOFF_REASON_OPTIONS
  );
  const waiveOffPenaltyOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];

  return (
    <Formik
      initialValues={{
        withdrawalSlider: withdrawalSlider,
        ...initialValuesFormik,
        [fields.requestedAmount]: isSpecificDollar(outerValues)
          ? remainingAmountToBeWithdrawn
          : null,

        ...initialValues,
        [fields.allocatedSourceWithdrawal]:
          (initialValuesFormik[fields.distributionMode] ||
            initialValues[fields.distributionMode]) &&
          CalculateProrationSplitUp(
            initialFilteredSourceBalance,
            0,
            getSourceWiseRequestAmountModelInitial(initialValues),
            true
          ),
      }}
      enableReinitialize
      onSubmit={onFormSubmit}
      validateOnChange={false}
      validateOnBlur={false}
      // validationSchema={validationSchema}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          setFieldError,
          fieldValue,
          resetForm,
          dirty,
          validateForm,
          errors,
          ...rest
        } = formProps;
        console.log("slider-values", values);
        let isCustomSourceAllocation =
          get(values, "sourceAllocationCalculationMethod") === 2;
        console.log("slider-values", values);
        const setIsCustomSourceAllocation = (value) =>
          setFieldValue("sourceAllocationCalculationMethod", 2);

        // console.log("slider-values", values);

        const grossAmountEffective =
          !calculationIsBasedOnGrossAmount ||
          isAllowMeToChooseTransaction(values)
            ? calculateGrossAmountFromNetAmountSourceWise(
                values,
                outerValues,
                filteredSourceBalances
              )
            : values[fields.grossAmount];

        console.log(
          "remainingGrossAmountToBeWithdrawn",
          remainingGrossAmountToBeWithdrawn,
          grossAmountEffective
        );
        const requestedAmountEffective = calculateRequestedAmountEffective(
          outerValues,
          values,
          filteredSourceBalances
        );

        const totalFeeEffective =
          getValues(values[fields.eftFee]) +
          getValues(values[fields.checkFee]) +
          getValues(values[fields.rollOverFee]);
        const grossAmountAfterFeeDeduction =
          grossAmountEffective - totalFeeEffective;
        const calculatePercentageValue = (fieldName) =>
          (
            (grossAmountAfterFeeDeduction * get(values, fieldName, 0)) /
            100
          )?.toFixed(2);

        const temp = distributionModeOptions.findIndex(
          (x) =>
            x.distributionMode === values[fields.distributionMode] &&
            (!x.beneficiaryId ||
              x.beneficiaryId === values[fields.beneficiaryId])
        );
        const distributionModeIndexValue = temp === -1 ? null : temp;
        const getBankAccountDetailsOfBeneficiary = (beneficiary) => {
          if (!beneficiary) return {};
          return {
            employeeId: parseInt(censusId),
            nameOfTheFinancialInstitution: beneficiary.bankAccountName,
            accountHolderName: beneficiary.accountHolderName,
            typeOfAccount: beneficiary.bankAccountType,
            checkingSavingsAccountNumber: beneficiary.bankAccountNumber,
            abaRoutingNumberforBankOfCreditUnion: beneficiary.routingNumber,
          };
        };
        const aggregatedSourceAllocatedAmount = (
          values?.allocatedSourceWithdrawal ?? []
        ).reduce((a, b) => a + b.sourceEmployeeMap?.sourceWithdrawalAmount, 0);
        const getAddressDetailsOfBeneficiary = (address) => {
          if (!address) return {};
          return {
            employeeId: parseInt(censusId),
            checkPayableTo: address.name,
            address1: address.address1,
            address2: address.address2,
            address3: address.address3,
            primaryEmailAddress: "",
            alternativeEmailAddress: "",
            city: address.city,
            country: "",
            state: "",
            countryId: address.countryId,
            stateId: address.stateId,
            zipCode: address.countryId === 1 ? address.zipCode : "",
            foreignCountry:
              address.countryId == 2 ? address.foreignCountry : "",
            foreignState: address.countryId == 2 ? address.foreignState : "",
            foreignZipCode: address.countryId == 2 ? address.zipCode : "",
          };
        };

        const bankAccountDetails =
          values.distributionMode === DISTRIBUTION_WITHDRAWAL_MODE.beneficiary
            ? getBankAccountDetailsOfBeneficiary(
                beneficiaries.find((_) => _.id === values[fields.beneficiaryId])
              )
            : withdrawalRequestData.bankInformationDetails;
        const getAddressDetails = (valuesInput) =>
          valuesInput.distributionMode ===
          DISTRIBUTION_WITHDRAWAL_MODE.beneficiary
            ? getAddressDetailsOfBeneficiary(
                beneficiaries.find(
                  (_) => _.id === valuesInput[fields.beneficiaryId]
                )
              )
            : withdrawalRequestData.address;
        const netAvailableSourceBalance = CalculateNetAvailableAmountSplit(
          filteredSourceBalances ?? [],
          outerValues?.withdrawalType,
          feeAndTaxesModel(values),
          []
        ).availableNetAmountSplit;
        const proratedDataForSourceAllocation =
          calculationToBeBasedOnGrossAmount(outerValues) &&
          !isAllowMeToChooseTransaction(values)
            ? calculateNetAmountFromGrossAmount(
                values,
                outerValues,
                filteredSourceBalances
              )
            : CalculateProrationForSourceAllocation(
                netAvailableSourceBalance,
                requestedAmountEffective,
                false
              );
        console.log(
          "proratedDataForSourceAllocation",
          proratedDataForSourceAllocation
        );

        const onSourceAllocationCalculationMethodChange = (value) => {
          setFieldValue(fields.sourceAllocationCalculationMethod, value);
          if (value === SourceAllocationCalculationMethod.AllowMeToChoose) {
            setFieldValue([fields.customizeAllocationCalculationMethod], 1);
            setFieldValue(
              [fields.allocatedSourceWithdrawal],
              proratedDataForSourceAllocation
            );
          }
        };

        return (
          <Form
            autoComplete="off"
            className="mb-20 mt-10 header-button-form"
            onSubmit={handleSubmit}
          >
            <div
              style={{
                width: "100%",
                justifyContent: "space-between",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <h5 style={{ whiteSpace: "nowrap" }}>
                Add Withdrawal Allocation
              </h5>

              <div
                className="slider-delete-button"
                style={{ marginLeft: "auto" }}
                onClick={() => {
                  setShowDeleteConfirmation(true);
                }}
              >
                <FontAwesomeIcon icon={faTrashAlt} /> Delete
              </div>

              <div
                className="slider-cancel-button"
                onClick={() => {
                  if (dirty) setModalVisible(true);
                  else onCancelClick();
                }}
              >
                <Button variant="secondary" style={{ marginTop: "-10px" }}>
                  Cancel
                </Button>
              </div>

              <div
                className="slider-save-button"
                onClick={() => {
                  validateForm().then((err) => {
                    if (isEmpty(err)) {
                      onFormSubmit(
                        values,
                        resetForm,
                        grossAmountEffective,
                        requestedAmountEffective
                      );
                    }
                  });

                  setShowDeleteConfirmation(false);
                }}
              >
                <Button variant="primary" style={{ marginTop: "-10px" }}>
                  {"Save"}
                </Button>
              </div>
              {/* <hr /> */}
            </div>

            <div
              className="d-flex withdrawal-allocation-slider"
              style={{ position: "relative" }}
            >
              <div>
                <div>
                  {showDeleteConfirmation && (
                    <DeleteRecipientPopUp
                      onConfirm={() => {
                        setShowDeleteConfirmation(false);
                        onDeleteAllocation();
                      }}
                      onCancel={() => setShowDeleteConfirmation(false)}
                      recipientName={
                        distributionModeOptions.find(
                          (_) => _.value === distributionModeIndexValue
                        )?.label
                      }
                    />
                  )}
                  <WarningModal
                    show={modalVisible}
                    onHide={() => setModalVisible(false)}
                  >
                    <div className="remove-text">
                      <h4>Are you sure?</h4>
                      <p>Your changes may be lost. Do you want to continue ?</p>
                      <Button
                        type="button"
                        className="remove-btn mr-4"
                        onClick={onCancelClick}
                      >
                        Yes
                      </Button>
                      <Button
                        className="cancel-btn"
                        onClick={() => setModalVisible(false)}
                      >
                        No
                      </Button>
                    </div>
                  </WarningModal>
                  <Field
                    size="md"
                    name={"distributionModeIndex"}
                    isRequired
                    value={distributionModeIndexValue}
                    selectedValue={distributionModeIndexValue}
                    direction="bottom"
                    placeholder="Select distribution mode"
                    options={distributionModeOptions}
                    label="Select distribution mode"
                    validate={(value) => {
                      return [undefined, null, ""].includes(
                        distributionModeIndexValue
                      )
                        ? "Required"
                        : undefined;
                    }}
                    popupContent={
                      <SearchableList
                        label="Select distribution mode"
                        onSelect={(value) => {
                          let updatedValues = clearFieldValues({
                            values,
                            fieldsToClear: [
                              "isCustomSourceAllocation",
                              fields.customizeAllocationCalculationMethod,
                              fields.beneficiaryId,
                              fields.code,
                            ],
                          });
                          // setFieldValue("distributionModeIndex", value);
                          const distributionMode =
                            distributionModeOptions[value].distributionMode;
                          updatedValues[
                            fields.distributionMode
                          ] = distributionMode;
                          if (
                            distributionMode ===
                            DISTRIBUTION_WITHDRAWAL_MODE.beneficiary
                          ) {
                            updatedValues[fields.beneficiaryId] =
                              distributionModeOptions[value].beneficiaryId;
                            updatedValues[fields.beneficiaryName] =
                              distributionModeOptions[value].beneficiaryName;
                          }
                          if (
                            isEarlyWithdrawalPenaltyApplicable(updatedValues)
                          ) {
                            updatedValues[fields.earlyWithdrawalPenalty] =
                              selectedWithdrawalPlanSetUp.earlyWithdrawalPenalty;
                          }
                          updatedValues[fields.paymentMethod] = 1;
                          updatedValues[fields.eftFee] = null;
                          updatedValues[fields.checkFee] =
                            selectedWithdrawalPlanSetUp?.checkFees;
                          updatedValues[
                            fields.sourceAllocationCalculationMethod
                          ] = SourceAllocationCalculationMethod.Prorata;
                          updatedValues.selectAddressDetails = 1;
                          updatedValues["address"] = getAddressDetails(
                            updatedValues
                          );
                          updatedValues[fields.planName] = "";
                          updatedValues[fields.trusteeName] = "";
                          updatedValues[fields.iraNumber] = "";
                          updatedValues[
                            fields.rollOverFee
                          ] = isRolloverDistributionMode(distributionMode)
                            ? selectedWithdrawalPlanSetUp?.rollOverFee
                            : 0;
                          setValues({ ...values, ...updatedValues });
                        }}
                        options={distributionModeOptions}
                        selectedValue={distributionModeIndexValue}
                      />
                    }
                    component={FieldDropSide}
                  />
                  {errors.distributionMode ? (
                    <div
                      style={{
                        display: "block",
                        fontSize: "0.75rem",
                        marginTop: "-10px",
                        color: "#ff5050",
                      }}
                    >
                      {errors.distributionMode}
                    </div>
                  ) : null}
                  {calculationIsBasedOnGrossAmount ? (
                    <Field
                      size="xs"
                      isRequired
                      name={fields.grossAmount}
                      type="text"
                      autoComplete="off"
                      value={values[fields.grossAmount]}
                      className="mr-4"
                      disabled={outerValues[fields.modeOfPayment] === 2}
                      onChange={(e) => {
                        handleChange(e);
                        // onSourceAllocationCalculationMethodChange(1);
                      }}
                      label={"Allocation amount"}
                      component={FieldInputDollarBox}
                      preventNegative={true}
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "Required"
                          : isAllowMeToChooseTransaction(values) &&
                            grossAmountEffective.toFixed(2) !== value.toFixed(2)
                          ? "Withdrawal allocation amount should be equal to the gross amount allocated"
                          : value > remainingGrossAmountToBeWithdrawn
                          ? "Allocation amount is greater than maximum amount available for withdrawal"
                          : undefined;
                      }}
                    />
                  ) : (
                    <Field
                      size="xs"
                      isRequired
                      name={fields.requestedAmount}
                      type="text"
                      autoComplete="off"
                      value={values[fields.requestedAmount]}
                      className="mr-4"
                      onChange={handleChange}
                      label={"Allocation amount"}
                      min={0}
                      component={FieldInputDollarBox}
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "Required"
                          : value > remainingAmountToBeWithdrawn
                          ? "Allocation amount is greater than maximum amount available for withdrawal"
                          : isAllowMeToChooseTransaction(values) &&
                            requestedAmountEffective.toFixed(2) !==
                              value.toFixed(2)
                          ? "Withdrawal allocation amount should be equal to the sum of source allocation amount"
                          : grossAmountEffective >
                            maximumGrossWithdrawableAmount
                          ? "Gross amount is greater than maximum gross amount available for withdrawal"
                          : undefined;
                      }}
                    />
                  )}
                  <p className="body_color">
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      style={{ fontSize: "16px" }}
                      className="mr-2"
                      color="#828282"
                    />
                    {calculationIsBasedOnGrossAmount
                      ? `Maximum amount available for withdrawal $ ${getValues(
                          effectiveAmountWithdrawn(
                            remainingGrossAmountToBeWithdrawn
                          )
                        ).toFixed(2)}`
                      : ` You can allocate a maximum ${
                          isFullWithdrawal(outerValues) ? "" : "gross amount"
                        } of $ ${getValues(
                          isFullWithdrawal(outerValues)
                            ? remainingAmountToBeWithdrawn
                            : remainingGrossAmountToBeWithdrawn
                        ).toFixed(2)}`}
                  </p>
                  <div className="slider-heading">Payment Details</div>
                  <AddressAndBankDetailsComponent
                    {...props}
                    {...formProps}
                    bankAccountDetails={bankAccountDetails}
                    addressDetails={getAddressDetails(values)}
                    filteredValues={filteredValues}
                  />

                  {[
                    DISTRIBUTION_WITHDRAWAL_MODE.traditional_IRA,
                    DISTRIBUTION_WITHDRAWAL_MODE.roth_IRA,
                    DISTRIBUTION_WITHDRAWAL_MODE.employer_Sponsored,
                  ].includes(values[fields.distributionMode]) && (
                    <>
                      <Field
                        isRequired
                        name={fields.iraNumber}
                        label="Account / IRA no"
                        size="md"
                        type="text"
                        className="mt-3"
                        autoComplete="off"
                        value={values[fields.iraNumber]}
                        onChange={handleChange}
                        //disabled={isEdit && !isSave}
                        component={FieldInput}
                        validate={(value) => {
                          return [undefined, null, ""].includes(value)
                            ? "Required"
                            : undefined;
                        }}
                      />
                      <Field
                        isRequired
                        name={fields.trusteeName}
                        label="Company/Trustee name"
                        size="md"
                        type="text"
                        autoComplete="off"
                        value={values[fields.trusteeName]}
                        onChange={handleChange}
                        //disabled={isEdit && !isSave}
                        component={FieldInput}
                        validate={(value) => {
                          return [undefined, null, ""].includes(value)
                            ? "Required"
                            : undefined;
                        }}
                      />
                      <Field
                        isRequired
                        name={fields.planName}
                        label="Plan name"
                        size="md"
                        type="text"
                        autoComplete="off"
                        value={values[fields.planName]}
                        onChange={handleChange}
                        //disabled={isEdit && !isSave}
                        component={FieldInput}
                        validate={(value) => {
                          return [undefined, null, ""].includes(value)
                            ? "Required"
                            : undefined;
                        }}
                      />
                    </>
                  )}
                  <p className="fw-400 ft-14 Grey-Color mt-10">
                    Select 1099 Code
                  </p>
                  <Field
                    isRequired
                    size="md"
                    name={fields.code}
                    value={values[fields.code]}
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.CODE_OPTIONS_CASH_ROLLOVER
                    )}
                    direction="right"
                    placeholder="Select"
                    popupContent={
                      <SearchableList
                        label="Select a withdrawal type"
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.CODE_OPTIONS_CASH_ROLLOVER
                        )}
                        onSelect={(value) => {
                          setFieldValue(fields.code, value);
                        }}
                        selectedValue={values[fields.code]}
                      />
                    }
                    component={FieldDropSide}
                    validate={(value) => {
                      return [undefined, null, ""].includes(value)
                        ? "Required"
                        : undefined;
                    }}
                  />
                  {outerValues[fields.modeOfPayment] === 2 && (
                    <>
                      <SourceHierarchyComponent
                        fields={fields}
                        outerValues={outerValues}
                        setSliderOpen={setSliderOpen}
                        setShowDirtyCheckModal={setShowDirtyCheckModal}
                        setIsInnerFormDirty={setIsInnerFormDirty}
                        {...formProps}
                        sliderOpen={sliderOpen}
                        isInnerFormDirty={isInnerFormDirty}
                        onFormToggle={onFormToggle}
                        handleCancelClick={handleCancelClick}
                        handleConfirmClick={handleConfirmClick}
                        showDirtyCheckModal={showDirtyCheckModal}
                        employeePlans={employeePlans}
                        selectedPlan={selectedPlan}
                        InvestDetails={InvestDetails}
                        selectedWithdrawalPlanSetUp={
                          selectedWithdrawalPlanSetUp
                        }
                        handleChange={handleChange}
                        filteredSourceBalances={filteredSourceBalances}
                      />
                    </>
                  )}
                  {isEarlyWithdrawalPenaltyApplicable(values) && (
                    <>
                      <div className="slider-heading">
                        Early withdrawal penaty{" "}
                      </div>
                      <Field
                        isRequired
                        name={`waiveOffLimitApplicable`}
                        label="Waive off penalty"
                        size="sm"
                        options={waiveOffPenaltyOptions}
                        selectedValue={values?.waiveOffLimitApplicable}
                        onChange={(value) => {
                          setFieldValue("waiveOffLimitApplicable", value);
                          setFieldValue(fields.waiveOffLimitReason, null);
                          setFieldValue(fields.waiveOffLimit, null);
                        }}
                        //disabled={isEdit && !isSave}
                        component={FieldButtonGroup}
                        validate={(selectedValue) => {
                          return [undefined, null, ""].includes(selectedValue)
                            ? "Required"
                            : undefined;
                        }}
                      />
                      {values?.waiveOffLimitApplicable && (
                        <>
                          <Field
                            isRequired
                            size="md"
                            name={fields.waiveOffLimitReason}
                            value={values[fields.waiveOffLimitReason]}
                            direction="bottom"
                            options={waiveOffReasonOptions}
                            label="Reason for waiving penalty"
                            popupContent={
                              <SearchableList
                                label="Reason for waiving penalty"
                                options={waiveOffReasonOptions}
                                onSelect={(value) => {
                                  setFieldValue("waiveOffLimitReason", value);
                                }}
                                selectedValue={
                                  values[fields.waiveOffLimitReason]
                                }
                              />
                            }
                            component={FieldDropSide}
                            validate={(value) => {
                              return [undefined, null, ""].includes(value)
                                ? "Required"
                                : undefined;
                            }}
                          />
                          <div className="d-flex">
                            <Field
                              size="xxs"
                              isRequired
                              name={fields.waiveOffLimit}
                              label="Waive off percentage"
                              type="text"
                              autoComplete="off"
                              value={values[fields.waiveOffLimit]}
                              onChange={handleChange}
                              component={FieldInputPercentageBox}
                              validate={(value) => {
                                return [undefined, null, ""].includes(value)
                                  ? "Required"
                                  : undefined;
                              }}
                            />
                            <div
                              className="slider-heading"
                              style={{ marginTop: "40px" }}
                            >
                              ${" "}
                              {calculatePercentageValue(fields.waiveOffLimit) ??
                                0}
                            </div>
                          </div>
                        </>
                      )}

                      {values?.waiveOffLimitApplicable === false && (
                        <div className="d-flex">
                          <Field
                            size="xxs"
                            isRequired
                            name={fields.earlyWithdrawalPenalty}
                            label="Early withdrawal penalty"
                            disabled={true}
                            type="text"
                            autoComplete="off"
                            value={values[fields.earlyWithdrawalPenalty]}
                            onChange={handleChange}
                            component={FieldInputPercentageBox}
                            validate={(value) => {
                              return [undefined, null, ""].includes(value)
                                ? "Required"
                                : undefined;
                            }}
                          />
                          <div
                            className="slider-heading"
                            style={{ marginTop: "40px" }}
                          >
                            ${" "}
                            {calculatePercentageValue(
                              fields.earlyWithdrawalPenalty
                            ) ?? 0}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  {(outerValues[fields.modeOfPayment] !== 2 ||
                    values[fields.sourceAllocationCalculationMethod] ===
                      SourceAllocationCalculationMethod.Prorata) && (
                    <SourceAllocationComponentSlider
                      {...formProps}
                      filteredSourceBalances={filteredSourceBalances}
                      proratedDataForSourceAllocation={
                        proratedDataForSourceAllocation
                      }
                      fields={fields}
                      setFilteredSourceBalances={setFilteredSourceBalances}
                      setInitialFilteredSourceBalance={
                        setInitialFilteredSourceBalance
                      }
                      initialFilteredSourceBalance={
                        initialFilteredSourceBalance
                      }
                      sourceBalances={sourceBalances}
                      outerValues={outerValues}
                      isCustomSourceAllocation={isCustomSourceAllocation}
                      setIsCustomSourceAllocation={setIsCustomSourceAllocation}
                      requestedAmountEffective={requestedAmountEffective}
                      grossAmountEffective={grossAmountEffective}
                      selectedWithdrawalPlanSetUp={selectedWithdrawalPlanSetUp}
                      selectedIndex={selectedIndex}
                      onSourceAllocationCalculationMethodChange={
                        onSourceAllocationCalculationMethodChange
                      }
                      availableBalanceMapForEachSourceInvestment={
                        availableBalanceMapForEachSourceInvestment
                      }
                      setAvailableBalanceMapForEachSourceInvestment={
                        setAvailableBalanceMapForEachSourceInvestment
                      }
                      setFilteredSourceBalancesAndAvailableAmountSplit={
                        setFilteredSourceBalancesAndAvailableAmountSplit
                      }
                      effectiveAmountWithdrawn={effectiveAmountWithdrawn}
                    />
                  )}
                </div>
              </div>

              <div
                className="summary-card"
                style={{
                  top: showDeleteConfirmation && "9rem",
                }}
              >
                <SummaryComponent
                  fields={fields}
                  {...formProps}
                  requestedAmountEffective={requestedAmountEffective}
                  grossAmountEffective={grossAmountEffective}
                  outerValues={outerValues}
                  employeePlanDetails={employeePlanDetails}
                  filteredSourceBalances={filteredSourceBalances}
                  selectedWithdrawalPlanSetUp={selectedWithdrawalPlanSetUp}
                />
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default AddWithdrawalAllocation;
